import { render, staticRenderFns } from "./InsurancePlanForm.vue?vue&type=template&id=5ad55da6"
import script from "./InsurancePlanForm.vue?vue&type=script&lang=js"
export * from "./InsurancePlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports